import {
  PictogramB2BSpeciality40,
  PictogramBuildingCommissioning40,
  PictogramBuildingBuilding40,
  PictogramProductTrust40,
} from '@cian/ui-kit-design-tokens/pictograms';
import { Tooltip } from '@cian/ui-kit';
import { IconFunctionalInformationCircle16, IIconProps } from '@cian/ui-kit-design-tokens/icons';

import { FC } from 'react';

import styles from './Fact.css';

export type FactTypes = 'foundationYear' | 'inProgress' | 'onTime' | 'completed';

type FactProps = {
  title: string;
  text: string;
  description: string | undefined;
  type: FactTypes;
};

export const Fact: FC<FactProps> = ({ title, type, text, description }) => {
  const Icon = ((): FC<IIconProps> => {
    switch (type) {
      case 'foundationYear':
        return PictogramBuildingBuilding40;
      case 'inProgress':
        return PictogramB2BSpeciality40;
      case 'onTime':
        return PictogramProductTrust40;
      case 'completed':
        return PictogramBuildingCommissioning40;
    }
  })();

  return (
    <li className={styles['fact']} data-testid="Fact">
      <div className={styles['icon']}>
        <Icon data-testid={`Fact-icon--${type}`} color="icon-warning-default" />
      </div>
      <div data-testid="Fact-content" className={styles['content']}>
        <span className={styles['title']} data-testid="Fact-content-title">
          {title}
        </span>
        <span className={styles['text']} data-testid="Fact-content-text-container">
          {text}
          {description && (
            <span className={styles['info']} data-testid="Fact-content-icon-container">
              <Tooltip
                theme="white"
                title={
                  <span className={styles['tooltip-text']} data-testid="Fact-content-icon-tooltip">
                    {description}
                  </span>
                }
              >
                <div className={styles['inner-info']} data-testid="Fact-content-icon-wrapper">
                  <IconFunctionalInformationCircle16 data-testid="Fact-content-icon" />
                </div>
              </Tooltip>
            </span>
          )}
        </span>
      </div>
    </li>
  );
};
